<template>

  <div class="article-list">
    <div v-if="list.length > 0">
      <div
        v-for="(item, index) in list"
        :key="index"
      >
        <articleCard
          :item="item"
          @click="selectClick"
        />
      </div>
    </div>
    <div
      v-else
      class="blank-wrap"
    >
      <Blank />
    </div>
  </div>
</template>

    <script >

import articleCard from './components/article-card.vue';
import { learningArticleQueryArticleByTypes } from '@/common/apiGeneral.js';
import { Toast } from 'vant';
import Blank from '@/components/blank.vue';
import jsApi from '@/common/jsApi';

export default {
  components: {
    articleCard,
    Blank
  },
  data() {
    return {
      list: [],
      articleType: ''
    };
  },
  mounted() {
    if (this.$route.query.articleType) {
      this.articleType = this.$route.query.articleType;
    }
    this.queryLearningArticleQueryArticleByTypes();
  },
  created() {
    // 定义提供给原生调用的方法
    window.webViewDidAppear = () => {
      console.log('文章列表webViewDidAppear()');
      this.queryLearningArticleQueryArticleByTypes();
    };
  },
  methods: {
    async queryLearningArticleQueryArticleByTypes(type) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      try {
        if (!this.articleType) {
          return Toast('文章分类不能为空');
        }
        const res = await learningArticleQueryArticleByTypes({ articleType: this.articleType });
        if (res) {
          this.list = res;
        }
        this.$toast.clear();
      } catch (error) {
        this.$toast.clear();
        console.log(error);
      }
    },
    selectClick(item) {
      console.log(item);

      const url = window.location.href.split('#')[0];
      const detailUrl = url + `#/articleDetail?id=${item.id}`;
      console.log('detailUrl', detailUrl);

      jsApi.openWebView({
        url: detailUrl,
        title: '学习中心'
      });

    //   this.$router.push({
    //     name: 'articleDetail',
    //     query: {
    //       id: item.id
    //     }
    //   });
    }
  }
};

    </script>

  <style lang="scss" scoped>

  .article-list {
    min-height: 100vh;
    padding: 12px;
    background-color: #f2f3f5;

    .blank-wrap {
        padding-top: 230px;
    }
  }
  </style>
